// lib/api/error.ts
export class ApiError extends Error {
    code: string;
    detail?: string;
    status?: number;

    constructor(code: string, message: string, detail?: string, status?: number) {
        super(message);
        this.code = code;
        this.detail = detail;
        this.status = status;
        this.name = 'ApiError';
    }

    static fromAxiosError(error: any): ApiError {
        return new ApiError(
            error.code || 'UNKNOWN_ERROR',
            error.message || '알 수 없는 오류가 발생했습니다.',
            error.detail,
            error.status
        );
    }
}